export default "__VITE_ASSET__Co0$hqhe__"